export default [
  {
    label: "横排",
    value: "horizontal"
  },
  {
    label: "竖排",
    value: "vertical"
  },
  {
    label: "滑动",
    value: "slide"
  },
  {
    label: "一行3列",
    value: "13"
  },
  {
    label: "一行2列",
    value: "12"
  },
  {
    label: "瀑布",
    value: "pb"
  },
];
